// Simple heuristic, not a real entropy calculation — good enough to nudge people away from
// "password1" without pulling in a library. Shared by every place a user picks a new password:
// SettingsPage (change/set password), SignUp, ResetPassword.
export function passwordStrength(pw) {
    const labels = ['Too short', 'Weak', 'Fair', 'Good', 'Strong'];
    const colors = ['var(--error)', 'var(--error)', 'var(--warning)', 'var(--cat-teal)', 'var(--success)'];
    if (!pw) return { score: 0, label: '', color: colors[0] };
    if (pw.length < 8) return { score: 0, label: labels[0], color: colors[0] };
    let score = 1;
    if (pw.length >= 12) score++;
    if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) score++;
    if (/[0-9]/.test(pw)) score++;
    if (/[^a-zA-Z0-9]/.test(pw)) score++;
    const capped = Math.min(score, 4);
    return { score: capped, label: labels[capped], color: colors[capped] };
}
